import { ModelSnippetFn } from '../types';

const getOpenAIClientSnippet = ({ userId, appId, modelId }: { userId: string; appId: string; modelId: string; pat?: string }) => `\
import os
from openai import OpenAI

client = OpenAI(
    base_url="https://api.clarifai.com/v2/ext/openai/v1",
    api_key="REPLACE_WITH_YOUR_CLARIFAI_PAT",
)
response = client.chat.completions.create(
    model="https://clarifai.com/${userId}/${appId}/models/${modelId}",
    messages=[
        {"role": "system", "content": "Talk like a pirate."},
        {
            "role": "user",
            "content": "How do I check if a Python object is an instance of a class?",
        },
    ],
    temperature=0.7,
    stream=False, # stream=True also works, just iterator over the response
)
print(response)
`;

export const generatePythonSDKForLLMOpenAI: ModelSnippetFn = ({ userId, appId, modelId, pat }) => {
  return getOpenAIClientSnippet({
    userId,
    appId,
    modelId,
    pat: pat && pat !== 'YOUR_PAT_HERE' ? `"${pat}"` : 'os.environ["CLARIFAI_PAT"]',
  });
};
